import { CrudManager } from "./CrudManager";

export default function AdminTestimonials() {
  return (
    <CrudManager
      testidPrefix="admin-testimonials"
      title="Testimonials"
      description="Manage patient testimonials shown on the home page."
      endpoint="/admin/testimonials"
      columns={[
        { key: "photo_url", label: "Photo" },
        { key: "name", label: "Name" },
        { key: "condition", label: "Condition" },
        { key: "rating", label: "Rating" },
      ]}
      renderCell={(key, it) => {
        if (key === "photo_url") return it.photo_url ? <img src={it.photo_url} alt="" className="w-10 h-10 rounded-full object-cover" /> : <div className="w-10 h-10 rounded-full bg-slate-100" />;
        if (key === "rating") return "★".repeat(it.rating || 0);
        return it[key];
      }}
      emptyValues={{ name: "", condition: "", quote: "", photo_url: "", rating: 5, order: 0 }}
      fields={[
        { name: "name", label: "Patient name", type: "text" },
        { name: "condition", label: "Condition / role", type: "text", placeholder: "e.g. Cardiac patient, Mother of two" },
        { name: "quote", label: "Testimonial quote", type: "textarea", rows: 5 },
        { name: "photo_url", label: "Photo URL", type: "url" },
        { name: "rating", label: "Rating (1-5)", type: "number" },
        { name: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
